/**
 * Client B2C API — espace particulier (compte joueur).
 * Tokens stockés sous des clés SÉPARÉES de l'admin pour éviter tout conflit de session.
 */
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

const KEY = "client_access_token";
const RKEY = "client_refresh_token";
const UKEY = "client_user";

const clientHttp = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

clientHttp.interceptors.request.use((config) => {
  const t = sessionStorage.getItem(KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

clientHttp.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry) {
      original._retry = true;
      const refresh = sessionStorage.getItem(RKEY);
      if (refresh) {
        try {
          const res = await axios.post(`${API}/auth/refresh`, { refresh_token: refresh });
          sessionStorage.setItem(KEY, res.data.access_token);
          original.headers.Authorization = `Bearer ${res.data.access_token}`;
          return clientHttp(original);
        } catch {
          clientLogout();
        }
      } else {
        clientLogout();
      }
    }
    return Promise.reject(error);
  }
);

export function saveClientSession(data) {
  sessionStorage.setItem(KEY, data.access_token);
  sessionStorage.setItem(RKEY, data.refresh_token);
  sessionStorage.setItem(UKEY, JSON.stringify(data.user));
}

export function clientLogout() {
  sessionStorage.removeItem(KEY);
  sessionStorage.removeItem(RKEY);
  sessionStorage.removeItem(UKEY);
}

export function getClientUser() {
  try {
    const u = sessionStorage.getItem(UKEY);
    return u ? JSON.parse(u) : null;
  } catch {
    return null;
  }
}

export const clientAuthApi = {
  register: (email, password, prenom) =>
    clientHttp.post("/auth/register", { email, password, prenom }).then((r) => r.data),
  login: (email, password) =>
    clientHttp.post("/auth/login", { email, password }).then((r) => r.data),
};

export const clientApi = {
  me: () => clientHttp.get("/client/me").then((r) => r.data),
  reservations: () => clientHttp.get("/client/reservations").then((r) => r.data),
  reservation: (id) => clientHttp.get(`/client/reservations/${id}`).then((r) => r.data),
};
